import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import DialogActions from '@mui/material/DialogActions';
import React, { FC, memo, useCallback } from 'react';
import { useFormikContext } from 'formik';

const modalFormActionsStyles = makeStyles((theme) => ({
    borderShadow: {
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
        flexShrink: 0,
        backgroundColor: theme.palette.background.paper
    },
    padding2: {
        padding: theme.spacing(1.5, 3)
    },
    flexGridGap1: {
        display: 'flex',
        gridGap: theme.spacing(1)
    }
}));

interface Props {
    onClose: () => void;
    actionText: string;
    cancelText?: string | 'Cancel';
    hasCancelButton: boolean;
    hasSecondAction: boolean;
    secondActionText?: string;
    setActionSubmitState?: React.Dispatch<React.SetStateAction<string>>;
}

const ActionButtons: FC<Props> = (props: Props) => {
    const {
        onClose,
        actionText,
        cancelText,
        hasCancelButton,
        hasSecondAction,
        secondActionText,
        setActionSubmitState
    } = props;
    const classes = modalFormActionsStyles();
    const formProps = useFormikContext();

    const handleSubmit = setActionSubmitState
        ? useCallback(
              (actionText) => {
                  setActionSubmitState(actionText);
                  formProps.handleSubmit();
              },
              [formProps]
          )
        : useCallback(() => {
              formProps.handleSubmit();
          }, [formProps]);
    return (
        <DialogActions className={classes.borderShadow + ' ' + classes.padding2}>
            <Grid container justifyContent="flex-end" className={classes.flexGridGap1}>
                {hasCancelButton && (
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        disabled={formProps.isSubmitting}
                    >
                        {cancelText}
                    </Button>
                )}
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    disabled={formProps.isSubmitting}
                >
                    {actionText}
                </Button>
                {hasSecondAction && (
                    <Button
                        onClick={() => handleSubmit(secondActionText)}
                        color="primary"
                        variant="outlined"
                        disabled={formProps.isSubmitting}
                    >
                        {secondActionText}
                    </Button>
                )}
            </Grid>
        </DialogActions>
    );
};

export default memo(ActionButtons);
